import { defineMessages } from 'react-intl-next';

export default defineMessages({
	backLabel: {
		id: 'fabric.editor.ai.components.backIconButton.backLabel',
		defaultMessage: 'Back',
		description: 'Back button label and tooltip',
	},
});
